import { IconButton } from "@mui/material";
import React, { Fragment, } from "react";
import { FiCheckCircle, FiClock, FiTablet } from "react-icons/fi";
import propTypes from "prop-types";

import styles from "../../../devices_admin/components/listItems/styles";
import flex from "../../../../../styles/flex";
import { IListActivationsResponse } from "../../../../../logic/api";
import { useDate } from "../../../../../utility/useDate";
import { FaWindowClose } from "react-icons/fa";

const DeviceActivationListItem: React.FunctionComponent<{
    activation: IListActivationsResponse,
}> = (props) => {
    const device = props.activation.device;

    const { toFormattedDateTimeString } = useDate();

    let createdByUser = [props?.activation.createdBy?.firstName ?? "", props?.activation.createdBy?.lastName ?? ""].filter((n) => n.length > 0).join(" ");
    if (createdByUser.length == 0) createdByUser = "-";
    const success = props?.activation.activation.success == true;
    const cancelled = props?.activation.activation.cancelled == true;
    const active = props?.activation.activation.active == true;
    const activated = success && props.activation.device != null;
    const err = active == false ? props.activation.activation.lastError : null;
    const expired = new Date(props.activation?.activation.expirationDate).getTime() < new Date().getTime();

    let status = "";
    let colour = "black";
    let message = "";

    const getIcon = () => {
        if (activated) {
            status = "ACTIVATED";
            colour = "green";
            message = "The device was successfully Activated";
            return <FiCheckCircle color={colour} />
        } else if (cancelled) {
            status = "CANCELLED";
            colour = "orange";
            return <FaWindowClose color={colour} />
        } else if (expired) {
            status = "EXPIRED";
            colour = "red";
            message = "The activation has now expired";
            return <FiClock color={colour} />
        } else if (active == false) {
            status = "ABORTED";
            colour = "orange";
            message = "The activation is no longer valid";
            return <FiClock color={colour} />
        } else if (active) {
            status = "PENDING";
            colour = "blue";
            message = "The activation is pending";
            return <FiClock color={colour} />

        } else {
            status = "";
            return <FiTablet color={"black"} />
        }
    }

    message = err ?? message;

    return (
        <Fragment>
            <div style={{ ...styles.listItem }}>

                <div style={{ ...flex.flexRows, justifyContent: "center", alignItems: "center" }}>

                    <div style={flex.flexAuto}>
                        <div style={{ marginRight: 10 }}>
                            <IconButton disabled={true}>
                                {getIcon()}
                            </IconButton>

                        </div>
                    </div>
                    <div style={{ ...flex.flexFill, textAlign: "left", minWidth: 400 }}>


                        <div>
                            <b>{((device?.alias ?? "").length > 0 ? device?.alias : device?.name) ?? "Not assigned to a device"}</b>
                        </div>
                        {
                            (device?.alias ?? "").length > 0 && (
                                <div>
                                    {device?.name}
                                </div>
                            )
                        }

                        <div style={{ marginTop: 5, backgroundColor: "#00eeeee" }}>
                            <b style={{ color: colour }}>{status}:</b>  <b style={{ color: colour }}>{message}</b>
                        </div>
                    </div>

                    <div style={{ ...flex.flexFill, textAlign: "left" }}>
                        <div>
                            Config:
                        </div>
                        <b>{props.activation.config?.name}</b>


                    </div>

                    <div style={{ ...flex.flexFill, textAlign: "left" }}>
                        <div>
                            Created
                        </div>
                        <div>
                            <div>
                                <b>{createdByUser}</b>, <b>{toFormattedDateTimeString(props.activation?.activation.created)}</b>
                            </div>


                        </div>
                    </div>


                    {(activated == false && active == true) && (
                        <div style={{ ...flex.flexFill, textAlign: "left" }}>
                            <div>
                                {expired ? "Expired:" : "Expires:"}
                            </div>
                            <div>
                                <b>{toFormattedDateTimeString(props.activation?.activation.expirationDate)}</b>
                            </div>
                        </div>
                    )}


                    {activated == false && active == false && (
                        <div style={{ ...flex.flexFill, textAlign: "left" }}></div>
                    )}

                    {activated == true && (
                        <div style={{ ...flex.flexFill, textAlign: "left" }}>
                            <div>
                                Activated:
                            </div>
                            <div>
                                <b>{toFormattedDateTimeString(props.activation?.device?.activationDate)}</b>
                            </div>
                        </div>
                    )}



                </div>

            </div >

        </Fragment >
    );
}

DeviceActivationListItem.propTypes = {
    activation: propTypes.any.isRequired,
}

export default DeviceActivationListItem;


